import AustinWiley5 from '../../assets/images/austin_wiley_5.png'
import YovelZoosman50 from '../../assets/images/yovel_zoosman_50.png'
import NirPerri14 from '../../assets/images/nir_perri_14.png'
import OrCornelius80 from '../../assets/images/or_cornelius_80.png'
import KhadeehCarrihgton3 from '../../assets/images/khadeeh_carrihgton_3.png'
import NoamDovrat8 from '../../assets/images/noam_dovrat_8.png'
import GabiChachashvili7 from '../../assets/images/gabi_chachashvili_7.png'
import JaredHarper1 from '../../assets/images/jared_harper_1.png'
import YarinHasson18 from '../../assets/images/yarin_hasson_18.png'
import ChrisJohnson4 from '../../assets/images/chris_johnson_4.png'
import JustinSmith0 from '../../assets/images/justin_smith_0.png'
import NimrodLevi15 from '../../assets/images/nimrod_levi_15.png'
import JeremyMorgan20 from '../../assets/images/jeremy_morgan_20.png'
import { IfavoritePlayer } from 'types/interfaces/IfavoritePlayerOptions'
export const favoritePlayerOptions: IfavoritePlayer[] = [
  { id: 0, src: '', label: 'none', labelHebrew: 'בחר/י' },
  {
    id: 1,
    src: AustinWiley5,
    label: 'Austin Wiley',
    labelHebrew: 'אוסטין וויילי',
  },
  {
    id: 2,
    src: YovelZoosman50,
    label: 'Yovel Zoosman',
    labelHebrew: 'יובל זוסמן',
  },
  {
    id: 3,
    src: NirPerri14,
    label: 'Nir Perri',
    labelHebrew: 'ניר פרי',
  },
  {
    id: 4,
    src: OrCornelius80,
    label: 'Or Cornelius',
    labelHebrew: 'אור קורנליוס',
  },
  {
    id: 5,
    src: KhadeehCarrihgton3,
    label: 'Khadeeh Carrihgton',
    labelHebrew: 'קאדין קרינגטון',
  },
  {
    id: 6,
    src: NoamDovrat8,
    label: 'Noam Dovrat',
    labelHebrew: 'נועם דוברת',
  },
  {
    id: 7,
    src: GabiChachashvili7,
    label: 'Gabi Chachashvili',
    labelHebrew: 'גבריאל צאצאשוילי',
  },

  {
    id: 8,
    src: JaredHarper1,
    label: 'Jared Harper',
    labelHebrew: 'ג׳ארד הארפר',
  },
  {
    id: 9,
    src: YarinHasson18,
    label: 'Yarin Hasson',
    labelHebrew: 'ירין חסון',
  },
  {
    id: 10,
    src: ChrisJohnson4,
    label: 'Chris Johnson',
    labelHebrew: 'כריס ג׳ונסון',
  },
  {
    id: 11,
    src: JustinSmith0,
    label: 'Justin Smith',
    labelHebrew: 'ג׳סטין סמית׳',
  },
  {
    id: 12,
    src: NimrodLevi15,
    label: 'Nimrod Levi',
    labelHebrew: 'נמרוד לוי',
  },
  {
    id: 13,
    src: JeremyMorgan20,
    label: 'Jeremy Morgan',
    labelHebrew: 'ג׳רמי מורגן',
  },
]
